import React from "react";
import TrackVisibility from "react-on-screen";
import MondayFormModal from "../../elements/modal/MondayFormModal";
import { useState } from "react";
import { FiArrowRight } from "react-icons/fi";

const SlipGrantStudent = () => {
  const [isModalOpen, setModalOpen] = useState(false);

  function showModal() {
    setModalOpen(true);
  }
  function closeModal() {
    setModalOpen(false);
  }
  return (
    <div className="rn-splite-style bg-color-blackest">
      <div className="split-wrapper">
        <div className="row no-gutters radius-10 align-items-center ">
          <div
            className="col-12 height-750 bg_image "
            data-black-overlay="5"
            style={{
              backgroundImage: `url(${process.env.PUBLIC_URL}/images/split/workforcebasics.jpg)`,
              backgroundAttachment: "local",
              backgroundSize: "cover",
            }}
          >
            <div
              className="split-inner text-center"
              style={{ margin: "0 auto" }}
            >
              <h2 className="title" style={{ color: "#EE6C4D" }}>
                Self-Advocacy Skills for Workplace Success
              </h2>{" "}
              <h5 style={{ color: "#FFF" }}>
                Looking to build your Self-Advocacy skills?
              </h5>
              <div className="content text-center">
                <TrackVisibility once>
                  <button className="btn-default" onClick={showModal}>
                    Sign Up!{" "}
                    <i className="icon">
                      <FiArrowRight />
                    </i>
                  </button>
                </TrackVisibility>
              </div>
            </div>
          </div>
        </div>
      </div>
      <MondayFormModal
        isOpen={isModalOpen}
        title="Grant Sign Up"
        onClose={closeModal}
        formUrl="https://forms.monday.com/forms/embed/50ff397be0f40caa54e964d5dcaf9357?r=use1"
      ></MondayFormModal>
    </div>
  );
};
export default SlipGrantStudent;
